<template>
  <div class="one">
    <span style="font-size:38px">星系异常查找使用数据介绍</span>
    <p>BGS，全称DESI Bright Galaxy
      Survey，顾名思义，其关注的是DESI中较亮的星系。我们知道，选择效应（由于仪器观测手段、观测能力等限制导致采样得到的统计分布与真实分布之间存在偏差，例如我们可能较难看到较暗的星系，导致我们认为的这类星系的数目比真实的少）是影响天文学研究的一个重要因素，而BGS在低红移(z&lt;0.6)处一般被认为是完备的（即不存在选择效应），因此可较好地用于星系形态等研究。该数据集的完整介绍可参考
      <a style="color:rgb(10,108,255)" href="https://arxiv.org/abs/2208.08512">DESI Bright Galaxy Survey: Final Target
        Selection, Design, and Validation</a> 。
    </p>

    <div>
      <img src="../assets/shuju2.jpg" alt="">
    </div>

    <p class="p-one">
      在批量化处理的过程中，以r波段的总流量和孔径测光流量作为主要的筛选指标，并以半光半径（即包含星系总光度一半处的半径）shape_r为标准，去除了数据中最小（shape_r &lt;= 6.4
      arcsec，因其尺寸过小，不适于进行目视形态分类）与最大（shape_r&gt;=25.6arcsec，因其过于稀少）的部分，并将剩余数据划分为small（6.4 arcsec&lt;shape_r&lt;9.6
      arcsec），medium（9.6 arcsec&lt;= shape_r&lt;12.8 arcsec），big（12.8 arcsec&lt;= shape_r&lt;19.2 arcsec）与ultra（19.2
      arcsec&lt;= shape_r&lt;25.6arcsec）四个部分，分别以它们的坐标为中心在DESI DR9中截取g，r，z三个波段192*192 pix，256*256 pix，384*384 pix和512*512
      pix的图像数据，采用<a style="color:rgb(10,108,255);text-decoration: none;"
        href="https://www.legacysurvey.org/viewer">Legacy Survey Sky Browser</a> 中的可视化函数转换为适于人眼观看的伪彩色图像，作为基础数据集开展下一步工作。
    </p>

    <div>
      <img src="../assets/shuju.jpg" alt="">
    </div>

    <p class="p-one">
      在将数据应用于标注前，利用图像自适应裁剪算法，使用户更关注其感兴趣的区域。使用深度神经网络进行了噪声数据的预筛选，能够去除1/10的干扰数据。同时利用基于天文大模型的贝叶斯分类网络将数据分为4类，椭圆、侧向星系、螺旋、异常。输出目标天体的概率分布，表示不同类别的概率，从而为每个天体提供了置信度作为用户标注的提示与参考。在引入不确定性的同时也造成模型输出类别的不确定度，例如模型对某一扩展天体属于某类的预测概率值最高仅为0.6，证明模型对于这个天体属于旋涡星系的预测并不是绝对确定的，因此需要进一步观察和研究该天体的其他特征，以确定其真实的分类。
    </p>
    <!-- 回到顶部 -->

    <el-row>
      <el-col :span="10" :offset="2">
        <div class="yi"><img src="../assets/shujuone.jpg" alt=""></div>
      </el-col>
      <el-col :span="10">
        <div class="yi"><img src="../assets/shujutwo.jpg" alt=""></div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="10" :offset="2">
        <div class="yi"><img src="../assets/shujuthree.jpg" alt=""></div>
      </el-col>
      <el-col :span="10">
        <div class="yi"><img src="../assets/shujufour.jpg" alt=""></div>
      </el-col>
    </el-row>

    <h4 style="color: rgb(0,0,255);">{{ text.dataintroduce.name }}:</h4>
    <p class="p-one" v-text="text.dataintroduce.text7"></p>
    <p class="p-one" v-text="text.dataintroduce.text8"></p>
    <p class="p-one" v-text="text.dataintroduce.text9"></p>
    <p class="p-one" v-text="text.dataintroduce.text10"></p>
    <p class="p-one" v-text="text.dataintroduce.text11"></p>
    <p class="p-one" v-text="text.dataintroduce.text12"></p>
    <p class="p-one" v-text="text.dataintroduce.text13"></p><br>

    <h6>参考文献:</h6>
    <p class="p-one" style="font-size: 12px;">1.冯时. 中国天文考古学. 北京: 社会科学文献出版社. 2001. ISBN 7-80149-602-7.</p>
    <p class="p-one" style="font-size: 12px;">2.陈久金; 杨怡. 中国古代天文与历法. 北京: 中国国际广播出版社. 2010. ISBN 978-7-5078-3163-4.</p>
    <p class="p-one" style="font-size: 12px;">3.维基百科. 二十八宿(2023-7-6). [2024-3-9]. <a
        href=" https://zh.wikipedia.org/wiki/%E4%BA%8C%E5%8D%81%E5%85%AB%E5%AE%BF#cite_note-FS-2.">
        https://zh.wikipedia.org/wiki/%E4%BA%8C%E5%8D%81%E5%85%AB%E5%AE%BF#cite_note-FS-2.</a>
    </p>
    <p class="p-one" style="font-size: 12px;">4.Zotti G , Hoffmann S M , Wolf A ,et al.The Simulated Sky: Stellarium for
      Cultural Astronomy
      Research[J].Journal
      of Skyscape Archaeology, 2021.DOI:10.1558/jsa.17822.</p>
    <p class="p-one" style="font-size: 12px;">5.百度百科. 四象(2024-1-31). [2024-3-9]. <a
        href=" https://baike.baidu.com/item/%E5%9B%9B%E8%B1%A1/324462#reference-11.">
        https://baike.baidu.com/item/%E5%9B%9B%E8%B1%A1/324462#reference-11.</a>
    </p>
    <p class="p-one" style="font-size: 12px;">6.邱靖嘉《天地之间：天文分野的历史学研究》［D］.北京：中华书局有限公司 2020.11</p>
    <p class="p-one" style="font-size: 12px;">7.开卷摘星辰——带你了解中国古代二十八星宿(2024-1-25). [2024-3-9]. <a
        href=" https://zhuanlan.zhihu.com/p/676317022."> https://zhuanlan.zhihu.com/p/676317022.</a>
    </p>
    <p class="p-one" style="font-size: 12px;">8.久金《中国古代二十八星宿》［M］.青海：青海人民出版社 2022.02</p>
    <p class="p-one" style="font-size: 12px;">9.夏鼐（中国科学院考古研究所）《从宣化辽墓的星图论二十八宿和黄道十二宫》［J］.哲学与人文科学考古学报1976.02期</p>
    <p class="p-one" style="font-size: 12px;">10.划分天区的坐标，二十八星宿详谈，二十八星宿星象图(2023-8-1). [2024-3-9]. <a
        href="https://baijiahao.baidu.com/s?id=1773034934167884992.">https://baijiahao.baidu.com/s?id=1773034934167884992.</a>
    </p>
    <p class="p-one" style="font-size: 12px;">11.中华三垣四象二十八宿(2023-6-18). [2024-3-9]. <a
        href="https://zhuanlan.zhihu.com/p/637907350.">https://zhuanlan.zhihu.com/p/637907350.</a>
    </p>
    <p class="p-one" style="font-size: 12px;">12.百度百科. 二十八星宿(2023-12-27). [2024-3-9]. <a
        href="https://baike.baidu.com/item/%E4%BA%8C%E5%8D%81%E5%85%AB%E6%98%9F%E5%AE%BF/675. ">https://baike.baidu.com/item/%E4%BA%8C%E5%8D%81%E5%85%AB%E6%98%9F%E5%AE%BF/675.
      </a>
    </p>


    <el-backtop :visibility-height="50" :bottom="120">
    </el-backtop>
  </div>
</template>

<script>
import { text, index } from '../config/text'
export default {
  data () {
    return {
      // 配置文件导入自动化展示=
      text: text[index]
    }
  }
}
</script>

<style lang="scss" scoped>
.one {
  color: rgb(44, 62, 80);

  p {
    font-size: 16px;
    margin-top: 10px;
    text-indent: 2em;
    line-height: 30px;
  }

  .p-one {
    font-size: 16px;
    text-align: justify;
    /*实现两端对齐*/
  }

  img {
    width: 100%;
    height: auto;
  }
}

.yi {
  img {
    width: 100%;
    height: auto;
  }
}
</style>